import { ReactElement, useEffect, useState } from 'react';
import { SwiperImages } from '~/ui/assets/mocks/swiperImages';
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import useSwiperRef from './useSwiperRef';
import { Mousewheel, Pagination, Navigation } from 'swiper/modules';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { useTranslation } from 'next-i18next';

interface SwiperProps {
  slides: SwiperImages[];
}

const Swiper = ({ slides }: SwiperProps): ReactElement => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();
  const [swiperKey, setSwiperKey] = useState(0);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1600px)');
    const handleResize = () => {
      setSwiperKey(prevKey => prevKey + 1);
    };

    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.addEventListener('change', handleResize);
    };
  }, []);
  return (
    <div className="swiper-container">
      <ReactSwiper
        key={swiperKey}
        modules={[Mousewheel, Pagination, Navigation]}
        navigation={{
          prevEl,
          nextEl,
        }}
        slidesPerView={1.55}
        spaceBetween={40}
        breakpoints={{
          // when window width is >= 480px

          660: {},
          960: {},
          1600: { slidesPerView: 2.5 },
        }}
      >
        {slides.map(slide => (
          <SwiperSlide key={slide.id}>
            <Link href={slide.url_key}>
              <picture>
                <source srcSet={`${slide.img}-mob.webp`} media="(max-width: 660px)" />
                <img
                  src={`${slide.img}.webp`}
                  alt={slide.alt}
                  width="798"
                  height="469"
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
              <p>{slide.tagline}</p>
              <h3>{slide.title}</h3>
              <p>{slide.description}</p>
              <Button variant="txt" ariaLabel={slide.alt}>
                {tButton('shopNow')}
              </Button>
            </Link>
          </SwiperSlide>
        ))}
        <div className="swiper-buttons">
          <button
            type="button"
            className="swiper-button swiper-button-prev"
            aria-label="Previous button"
            ref={prevElRef}
          >
            <i className="icon-left-arrow" />
          </button>
          <button
            type="button"
            className="swiper-button swiper-button-next"
            aria-label="Next button"
            ref={nextElRef}
          >
            <i className="icon-right-arrow" />
          </button>
        </div>
      </ReactSwiper>
    </div>
  );
};

export default Swiper;
